import MuteButton from './RestartButton';

export default MuteButton;
